/* eslint-disable */
import Choices from "choices.js";

const sortSelect = () => {
  const select = document.querySelector(".sort-select");
  if (select) {
    const dropdown = new Choices(".sort-select", {
      searchEnabled: false,
      itemSelectText: "",
      shouldSort: false
    });

    // Listen to changes and update the URL with our new sort value
    // Choices.js v10+ uses passedElement.element for the actual DOM node
    const selectElement = dropdown.passedElement.element || dropdown.passedElement;
    selectElement.addEventListener('change', e => {
      window.location.href = e.target.value;
    });
  }
};

export default sortSelect;
/* eslint-enable */
